// Black Friday pages: send the shopper's picks to the cart as real variants, then go straight to checkout.
// Variant ids / selling plans / discount code come from <script id="bf-variant-map"> (snippets/bf-variant-map.liquid).
// The add is a programmatic form POST (form.submit() fires no submit event and isn't fetch), so the Kaching cart
// drawer never opens; same flow as assets/bundle-lp.js.
(function () {
  function config() {
    var el = document.getElementById('bf-variant-map');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  // The code, or one per deal on deal-picker pages: "b3g2:CODE|b6g4:CODE|b9g6:CODE".
  function codeFor(code, deal) {
    if (!code || code.indexOf(':') < 0) return code;
    var hit = code.split('|').filter(function (p) { return p.split(':')[0] === deal; })[0];
    return hit ? hit.split(':')[1] : '';
  }

  // lines: { key: quantity }, keys match the variant map.
  // opts: { plan: 'sub'|'once', toast: fn, deal: deal key (picks the code), label: deal name (added to the Bundle line property) }
  window.bfCheckout = function (lines, opts) {
    opts = opts || {};
    var say = opts.toast || function (m) { window.alert(m); };
    var cfg = config();
    if (!cfg) { say('Something went wrong. Please try again.'); return; }

    var items = [], missing = [];
    Object.keys(lines).forEach(function (key) {
      var qty = lines[key];
      if (!qty) return;
      var v = cfg.variants[key];
      if (!v || !v.available) { missing.push(v && v.name ? v.name : key); return; }
      var item = { id: v.id, quantity: qty };
      if (opts.plan === 'sub' && v.plan) item.selling_plan = v.plan;
      items.push(item);
    });
    if (missing.length) { say('Sorry, ' + missing.join(', ') + ' is unavailable right now.'); return; }
    if (!items.length) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var code = codeFor(cfg.code, opts.deal);
    var bundle = cfg.bundle && opts.label ? cfg.bundle + ' · ' + opts.label : cfg.bundle;
    var next = code ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout' : '/checkout';

    // cart/clear.js keeps discount codes, so drop them too: a code left by another BF page would beat this one.
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/clear ' + res.status);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update ' + res.status);
        var form = document.createElement('form');
        form.method = 'post';
        form.action = root + 'cart/add';
        function field(name, value) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        }
        items.forEach(function (it, i) {
          field('items[' + i + '][id]', it.id);
          field('items[' + i + '][quantity]', it.quantity);
          if (it.selling_plan) field('items[' + i + '][selling_plan]', it.selling_plan);
          if (bundle) field('items[' + i + '][properties][Bundle]', bundle);
        });
        field('return_to', next);
        document.body.appendChild(form);
        form.submit();
      })
      .catch(function () { say('Something went wrong. Please try again.'); });
  };

  // Shop pages (no bundle): put the Black Friday code(s) on the cart on every visit (a bundle page may have cleared
  // them), so the drawer and checkout show it. Bundle pages apply their code on the way to checkout (see bfCheckout).
  document.addEventListener('DOMContentLoaded', function () {
    var cfg = config();
    if (!cfg || !cfg.code || cfg.bundle) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: cfg.code })
    }).catch(function () {});
  });
})();
